import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const articles = [
  {
    slug: '/artykul/kakobuy-spreadsheet-kompletny-przewodnik',
    title: 'Kakobuy Spreadsheet — Kompletny Przewodnik 2026',
    category: 'Poradnik',
    excerpt: 'Dowiedz się, jak efektywnie korzystać z arkuszy Kakobuy, poznaj najlepsze strategie wyszukiwania produktów i odkryj sekrety doświadczonych shopperów.',
    image: 'https://readdy.ai/api/search-image?query=An%20open%20laptop%20on%20a%20warm%20wooden%20desk%20showing%20a%20colorful%20organized%20spreadsheet%20with%20product%20listings%2C%20natural%20light%20streaming%20through%20a%20window%2C%20a%20ceramic%20coffee%20cup%20and%20a%20small%20potted%20succulent%20plant%20nearby%2C%20clean%20minimalist%20Scandinavian%20workspace%20aesthetic%2C%20cream%20and%20beige%20tones%2C%20soft%20shadows%2C%20editorial%20photography%20style%20with%20bright%20airy%20atmosphere&width=700&height=900&seq=article-card-guide-v2&orientation=portrait',
  },
  {
    slug: '/artykul/kakobuy-vs-cssbuy-vs-superbuy-porownanie',
    title: 'Kakobuy vs CSSBuy vs Superbuy — Porównanie 2026',
    category: 'Porównanie',
    excerpt: 'Który arkusz zakupowy wybrać? Szczegółowe porównanie trzech najpopularniejszych rozwiązań — funkcje, kategorie i dla kogo.',
    image: 'https://readdy.ai/api/search-image?query=Three%20elegant%20cards%20arranged%20in%20a%20row%20on%20a%20light%20beige%20textured%20surface%2C%20each%20card%20in%20a%20different%20soft%20pastel%20tone%20with%20subtle%20border%2C%20representing%20comparison%20and%20choice%20concept%2C%20minimal%20desk%20setting%20with%20a%20pen%20and%20notepad%2C%20natural%20diffused%20daylight%2C%20clean%20modern%20aesthetic%2C%20high%20end%20editorial%20style&width=700&height=900&seq=article-card-compare-v2&orientation=portrait',
  },
  {
    slug: '/artykul/kakobuy-spreadsheet-bezpieczenstwo-zakupow',
    title: 'Bezpieczeństwo Zakupów z Kakobuy Spreadsheet',
    category: 'Bezpieczeństwo',
    excerpt: 'Czy korzystanie z arkuszy Kakobuy jest bezpieczne? Wszystko o ochronie danych, weryfikacji produktów i bezpiecznych transakcjach.',
    image: 'https://readdy.ai/api/search-image?query=A%20translucent%20glass%20shield%20symbol%20on%20a%20warm%20cream%20linen%20surface%2C%20a%20laptop%20in%20the%20background%20displaying%20a%20secure%20shopping%20page%2C%20soft%20morning%20light%20from%20a%20large%20window%2C%20minimalist%20desk%20with%20a%20notebook%20and%20pen%2C%20feeling%20of%20trust%20safety%20and%20transparency%2C%20Scandinavian%20interior%2C%20soft%20shadows%2C%20editorial%20photography&width=700&height=900&seq=article-card-safety-v2&orientation=portrait',
  },
  {
    slug: '/artykul/najlepsze-znaleziska-kakobuy-spreadsheet-2026',
    title: 'Top 10 Znalezisk w Kakobuy Spreadsheet 2026',
    category: 'Znaleziska',
    excerpt: 'Lista must-have produktów z arkusza Kakobuy — sneakersy, streetwear, akcesoria i elektronika w bezkonkurencyjnych cenach.',
    image: 'https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20flat%20lay%20of%20fashionable%20products%20including%20a%20pair%20of%20white%20sneakers%20a%20leather%20watch%20designer%20sunglasses%20and%20a%20small%20leather%20bag%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20light%20casting%20gentle%20shadows%2C%20editorial%20lifestyle%20photography%20with%20harmonious%20neutral%20tones%2C%20aspirational%20and%20clean%20aesthetic&width=700&height=900&seq=article-card-finds-v2&orientation=portrait',
  },
];

export default function ArticleSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-semibold text-accent-700 bg-accent-50/60">
            {t('article.label')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-5">
            Artykuły i Poradniki SEO
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Eksperckie artykuły o Kakobuy Spreadsheet, porównania arkuszy i porady zakupowe
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <button
              key={article.slug}
              onClick={() => navigate(article.slug)}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all overflow-hidden text-left cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden bg-accent-100/40">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <span className="text-[11px] font-semibold text-accent-600 bg-accent-50/70 px-2.5 py-1 rounded-full w-fit mb-3">
                  {article.category}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:gap-2 transition-all">
                  <span>{t('article.read_more')}</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}